import React from 'react';
import { hot } from 'react-hot-loader';
import CacheBuster from 'react-cache-buster';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { version } from '../../../package.json';
import Router from './Router';
import Theme from './Theme';
import store from '../../redux/store';
import config from '../../config';
import PronunciationWidget from '../PronunciationWidget/PronunciationWidget';

const configuration = {
  auth: {
    clientId: config.AZURE_CLIENT_ID,
  },
};

const pca = new PublicClientApplication(configuration);

const AppContent = () => {
  const user = useSelector((state) => state.user);
  const accounts = pca.getAllAccounts();

  const isLoggedIn = Boolean(user?.userData) || (accounts && accounts.length > 0);

  return (
    <Theme>
      <BrowserRouter>
        <Router />
        {isLoggedIn && <PronunciationWidget />}
      </BrowserRouter>
    </Theme>
  );
};

const App = () => {
  const isProduction = process.env.NODE_ENV === 'production';

  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction}
      isVerboseMode={false}
    >
      <MsalProvider instance={pca}>
        <Provider store={store}>
          <AppContent />
        </Provider>
      </MsalProvider>
    </CacheBuster>
  );
};

if (module.hot) {
  module.hot.accept();
}

export default hot(module)(App);
